module.exports = __webpack_public_path__ + "static/media/total_users.a9c7a176.svg";